export const createUploadFileRequest = (url, sourceType, fileName = null) => {
  return {
    url: "/knowledge_base/ingest",
    method: "POST",
    data: {
      url: url,
      source_type: sourceType,
      ...(fileName && { file_name: fileName }),
    },
  };
};

export const createGetKnowledgeBaseItemsRequest = (page = 1, per_page = 20) => {
  return {
    url: "/knowledge_base",
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createDeleteKnowledgeBaseItemRequest = (id) => {
  return {
    url: "/knowledge_base/" + id,
    method: "DELETE",
  };
};

export const createExtractLinksRequest = (url) => {
  return {
    url: "/knowledge_base/extract_links",
    method: "POST",
    data: {
      url: url,
    },
  };
};

export const createBulkIngestUrlsRequest = (sourceUrl, childUrls, fileName = null) => {
  return {
    url: "/knowledge_base/bulk_ingest_urls",
    method: "POST",
    data: {
      source_url: sourceUrl,
      child_urls: childUrls,
      ...(fileName && { file_name: fileName }),
    },
  };
};